import React from 'react';

const card = {
  background: '#fff',
  borderRadius: 10,
  padding: 24,
  marginBottom: 16,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
};

const label = {
  fontSize: 13,
  fontWeight: 600,
  marginBottom: 6,
  display: 'block',
};

const th = {
  fontSize: 12,
  fontWeight: 600,
  padding: '8px 10px',
  textAlign: 'left',
  background: '#f8fafc',
  borderBottom: '2px solid #e2e8f0',
};

const td = {
  fontSize: 12,
  padding: '7px 10px',
  borderBottom: '1px solid #e2e8f0',
};

export default function ItemMasterTab({ imRef, handleItemMaster, imStatus, imCount, ADS }) {
  return (
    <div style={{ maxWidth: 900, margin: '0 auto' }}>
      {/* Upload */}
      <div style={card}>
        <span style={label}>Upload ItemMaster (CSV / TSV)</span>
        <input
          ref={imRef}
          type="file"
          accept=".csv,.tsv,.txt"
          onChange={handleItemMaster}
          style={{ fontSize: 13 }}
        />
        {imStatus && (
          <span
            style={{
              marginLeft: 12,
              fontSize: 12,
              padding: '3px 10px',
              borderRadius: 12,
              background: imCount > 0 ? '#dcfce7' : '#fef9c3',
              color: imCount > 0 ? '#166534' : '#854d0e',
              fontWeight: 600,
            }}
          >
            {imCount > 0 ? `${imCount} items loaded` : imStatus}
          </span>
        )}
      </div>

      {/* ADS Pricing Table */}
      <div style={card}>
        <span style={label}>ADS Pricing Keys</span>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={th}>Key</th>
                <th style={th}>Part Number</th>
                <th style={{ ...th, textAlign: 'right' }}>LPP ($)</th>
                <th style={th}>Source</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(ADS).map(([key, item]) => {
                const matched = item._matched;
                return (
                  <tr
                    key={key}
                    style={matched ? { background: '#f0fdf4' } : undefined}
                  >
                    <td style={{ ...td, fontFamily: 'monospace', fontWeight: 600 }}>{key}</td>
                    <td style={td}>{item.pn || '--'}</td>
                    <td style={{ ...td, textAlign: 'right' }}>
                      {item.lpp != null ? `$${Number(item.lpp).toFixed(2)}` : '--'}
                    </td>
                    <td style={td}>
                      {matched ? (
                        <span style={{ color: '#16a34a', fontWeight: 600, fontSize: 11 }}>
                          ItemMaster
                        </span>
                      ) : (
                        <span style={{ color: '#94a3b8', fontSize: 11 }}>Default</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
